import { Component, Inject, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { FbPixelService } from './service/fb-pixel.service';
import { SeoService } from './service/seo.service';
import { environment } from '../environments/environment';
import { CookieConsentComponent } from './shared/cookie-consent/cookie-consent.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, CookieConsentComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'whatsapp-ai-chatbot';
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private seoService = inject(SeoService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private fb: FbPixelService
  ) {
    if (isPlatformBrowser(this.platformId) && environment.fbPixel?.enabled) {
      const consentGranted = localStorage.getItem('cookie-consent-granted') === 'true';
      if (consentGranted) {
        this.fb.init();
      }
    }
    
  }

  ngOnInit(): void {
    // Automatically listen to router NavigationEnd to update SEO metadata for active route
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((route) => {
        const seoData = route.snapshot.data['seo'];
        if (seoData) {
          this.seoService.updateSeo(seoData);
        } else {
          // Default route fallback SEO if no route data defined
          this.seoService.updateSeo({});
        }
      });
  }
}
